import { render, staticRenderFns } from "./GerenciamentoChat.vue?vue&type=template&id=e1d72c96"
import script from "./GerenciamentoChat.vue?vue&type=script&lang=js"
export * from "./GerenciamentoChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports